import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { startCheckout } from '../lib/checkout';

export default function Dashboard() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Check for OAuth errors in URL
    const params = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace('#', '?'));
    const urlError = params.get('error') || hashParams.get('error');
    const errorDesc = params.get('error_description') || hashParams.get('error_description') || '';

    if (urlError) {
      console.log('[Dashboard] OAuth error:', urlError, errorDesc);
      setError(true);
      return;
    }

    const doRedirect = async (session, source) => {
      if (done) return;
      setDone(true);
      if (!session?.user) {
        navigate('/', { replace: true });
        return;
      }
      const { data: profile } = await supabase
        .from('profiles')
        .select('onboarding_done')
        .eq('id', session.user.id)
        .single();

      // Check for pending checkout from Landing
      const pendingCheckout = localStorage.getItem('td_pending_checkout');
      if (pendingCheckout && session?.user) {
        localStorage.removeItem('td_pending_checkout');
        startCheckout(pendingCheckout, session.user, null);
        return;
      }

      // Check for pending redirect (e.g. from Onsite project card)
      const pendingRedirect = sessionStorage.getItem('td_redirect_after_login');
      if (pendingRedirect && profile?.onboarding_done) {
        sessionStorage.removeItem('td_redirect_after_login');
        navigate(pendingRedirect, { replace: true });
        return;
      }

      navigate(profile?.onboarding_done ? '/sala' : '/arbol', { replace: true });
    };

    const hasOAuthParams = window.location.hash.includes('access_token') ||
                           window.location.search.includes('code=');

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        doRedirect(session, 'SIGNED_IN');
      }
      if (event === 'INITIAL_SESSION') {
        if (session?.user) {
          doRedirect(session, 'INITIAL_SESSION');
        } else if (!hasOAuthParams) {
          navigate('/', { replace: true });
        }
      }
    });

    const t1 = setTimeout(async () => {
      if (done) return;
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        doRedirect(session, 'fallback');
      } else {
        setError(true);
      }
    }, 6000);

    return () => { subscription.unsubscribe(); clearTimeout(t1); };
  }, []);

  if (error) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans', sans-serif", padding:'2rem', textAlign:'center' }}>
        <div>
          <p style={{ fontSize:32, marginBottom:12 }}>😕</p>
          <p style={{ fontSize:18, fontWeight:500, marginBottom:8 }}>Hubo un problema al iniciar sesión</p>
          <p style={{ fontSize:14, color:'#999', marginBottom:24, lineHeight:1.6 }}>Puede ser un error temporal. Inténtalo de nuevo.</p>
          <button onClick={() => navigate('/', { replace: true })} style={{
            background:'linear-gradient(135deg, #534AB7, #1D9E75)', color:'#fff',
            border:'none', borderRadius:50, padding:'12px 32px', fontSize:15,
            fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans', sans-serif",
          }}>Volver a intentar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans', sans-serif", flexDirection:'column', gap:12 }}>
      <div style={{ width:44, height:44, borderRadius:'50%', background:'linear-gradient(135deg, #534AB7, #1D9E75)', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <span style={{ color:'#fff', fontSize:14, fontWeight:600 }}>T&D</span>
      </div>
      <p style={{ color:'#999', fontSize:14 }}>Procesando login...</p>
    </div>
  );
}
